<template>
	<div>
		<v-col v-if="imagenes.length > 0" cols="12" class="px-0 pt-0">
			<v-slide-group show-arrows class="custom-slider-class" ref="slider">
				<v-slide-item
					v-for="(imagen, index) in imagenes"
					:key="`item-${index}`"
				>
					<v-card
						class="mr-4 mt-4"
						style="min-height: 150px; min-width: 150px"
					>
						<v-container
							fluid
							class="pa-0 d-flex align-center justify-center fill-height"
						>
							<v-btn
								x-small
								fab
								color="error"
								top
								right
								absolute
								style="right: -15px"
								elevation="2"
								:disabled="disabled"
								@click="deleteImage(index, imagen)"
							>
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
							<v-scale-transition>
								<v-img
									:src="imagen.imgBase64"
									aspect-ratio="1.0"
								></v-img>
							</v-scale-transition>
						</v-container>
					</v-card>
				</v-slide-item>
			</v-slide-group>
		</v-col>
		<v-btn
			color="primary"
			block
			@click="dialogCamera = true"
			:disabled="loading || disabled"
			:loading="loading"
			>Agregar Fotografía
			<v-icon right color="white">mdi-camera</v-icon>
		</v-btn>
		<EasyCamera
			v-if="dialogCamera"
			:fullscreen="true"
			:fullscreenZIndex="301"
			:autoDetectMobile="true"
			:mustApprove="true"
			output="blob"
			@approve="saveImage"
			@close="dialogCamera = false"
		/>
	</div>
</template>

<script>
import EasyCamera from "easy-vue-camera";
import axios from "axios";
import moment from "moment";

export default {
	components: { EasyCamera },
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		nombreComprobacion: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false
		},
		documentosRegistrados: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			dialogCamera: false,
			imgBase64: null,
			loading: false,
			imagenes: [],
		};
	},
	mounted(){
		if(this.documentosRegistrados.length > 0){
			for (const documentoRegistrado of this.documentosRegistrados) {
				this.descargarDocumento(documentoRegistrado);
			}
		}
	},
	methods: {
		truncateString(str, length = 24, finalChars = true){
			if(str.length <= length) return str;
			else{
				return `${str.substring(0,length)}${finalChars ? '...' : ''}`;
			}
		},
		descargarDocumento({ idDocumento, nombre }){
			this.loading = true;

			axios({
				url: `/Documentos/Descargar/${nombre}`,
				method: 'GET',
				responseType: 'blob'
			})
				.then(async(response) => {
					this.$emit("input", [
						...this.value,
						idDocumento,
					]);
					const blob = new Blob([response.data], {
						type: "application/octet-stream",
					});
					await this.renderImage(blob, nombre);
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					console.log(error);
				});
		},
		generarNombreFotografia() {
			const truncatedName = this.truncateString(this.nombreComprobacion, 24, false);
			return `foto-${truncatedName}-${moment().format(
				"YYYYMMDDHHmmss"
			)}`;
		},
		deleteImage(index, imagen) {
			axios
				.put(`/Documentos/Eliminar/${imagen.nombre}`)
				.catch(console.log);
			this.imagenes.splice(index, 1);
			this.$emit(
				"input",
				this.value.filter((_, idx) => idx != index)
			);
		},
		async saveImage($event) {
			this.dialogCamera = false;
			this.loading = true;
			const filename = this.generarNombreFotografia();
			const file = new File([$event], `${filename}.png`, {
				type: "image/png",
			});
			let formData = new FormData();
			formData.append("ficheros", file);
			axios
				.post(`/Documentos/Cargar?titulo=${filename}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(async (response) => {
					this.$emit("input", [
						...this.value,
						response.data[0].idDocumento,
					]);
					
					await this.renderImage($event, response.data[0].nombre);
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					console.log(error);
				});
		},
		async renderImage(blob, nombre){
			const imgBase64 = await this.blobToBase64(blob);
			this.imagenes.push({
				imgBase64,
				nombre,
			});
			setTimeout(() => {
				this.$refs.slider.scrollTo();
			}, 200);
		},
		blobToBase64(blob) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onload = () => {
					return resolve(reader.result);
				};
				reader.onerror = (error) => {
					return reject(error);
				};
			});
		},
	},
};
</script>
<style scoped>
.custom-slider-class >>> .v-slide-group__content {
	justify-content: center;
}

.custom-slider-class >>> .v-slide-group__next {
	min-width: min-content;
}

.custom-slider-class >>> .v-slide-group__prev {
	min-width: min-content;
}

.custom-slider-class >>> .v-icon {
	font-size: 22px !important;
}
</style>